export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.5 2.032a2 2 0 012.336 2.203l-.739 6.28a2.001 2.001 0 01-1.986 1.766h-4.858l-2.459 8.553a2 2 0 01-1.921 1.447H7a2 2 0 01-2-2v-8.175a2.998 2.998 0 01-2-2.825V7.304C3 5.85 4.044 4.605 5.475 4.35L18.5 2.032zM7 12.28v8h1.873l2.3-8H7zM5.826 6.32A1 1 0 005 7.304v1.977a1 1 0 001 1h12.11L18.85 4 5.826 6.32z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};